import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TextArea extends Component {
  constructor (props) {
    super(props);
    this.state = {
      value: props.value,
      error: false
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange (e) {
    const name = this.props.name;
    const value = e.target.value;
    const error = this.props.validate ? this.props.validate(value) : false;
    this.setState(
      {
        value,
        error
      });
    this.props.onChange(
      {
        name,
        value,
        error
      });
  }

  componentWillReceiveProps (update) {
    this.setState(
      {
        value: update.value
      }
    );
  }

  render () {
    return (
      <span>
        <textarea
          name={this.props.name}
          value={this.state.value}
          maxLength={this.props.maxLength}
          placeholder={this.props.placeHolder}
          onChange={this.onChange}
          onBlur={this.onChange}
          className={this.props.class + ' ' + (this.state.error ? 'has-error' : '')}
        />
        <span className='error-message'>{this.state.error}</span>
      </span>
    );
  }
}

TextArea.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  maxlength: PropTypes.number,
  class: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  validate: PropTypes.func
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/Field/textarea.js